import {Grid, Typography} from "@material-ui/core";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import i18n from "../../../../i18nextInitiator";

const t = i18n.getFixedT('fa','general');

const useStyles = makeStyles((theme) => ({
    plateBox:{
        border: `solid 0.5px #adb5bd`,
        borderRadius: 2,
        backgroundColor:"#fff",
        padding: "0 .2rem"
    },
    secPlateBox:{
        '& > *': {
            padding: " .42rem .2rem"
        },
    },
    plateIran:{
        fontSize:".6rem",
        textAlign:"center"
    },
}))

const TruckPlate = (props) => {
    const classes = useStyles()
    return <Grid item>
        {props.driver && props.driver.plate && props.driver.plate.city_digits &&
        <Grid container>
            <Grid className={classes.plateBox} item alignItems="center">
                <div className={classes.plateIran}>{t('invoice.iran')}</div>
                <Typography variant="body2">{props.driver.plate.city_digits}</Typography>
            </Grid>
            <Grid className={classes.plateBox} item>
                <Grid container className={classes.secPlateBox}>
                    <Typography variant="body2">{props.driver.plate.three_digits}</Typography>
                    <Typography variant="body2">{props.driver.plate.letter}</Typography>
                    <Typography variant="body2">{props.driver.plate.two_digits}</Typography>
                </Grid>
            </Grid>
        </Grid>
        }
    </Grid>
}

export default TruckPlate;